import script from "./FormRevision.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormRevision.vue?vue&type=script&setup=true&lang=ts"

import "./FormRevision.vue?vue&type=style&index=0&id=6c652f21&lang=css"

const __exports__ = script;

export default __exports__